<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    name: "BoardingFilter",
    props: {
        value: Object,
        category: String,
        title: String,
    },
    setup(props, {emit}) {
        const {workerPhases, validationWorkFlowStatus, boardingStatus} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({
            category: props.category,
        });

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});


        return {
            filter,
            workerPhases,
            validationWorkFlowStatus,
            boardingStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ title }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                        v-model="filter.workerId"
                                        :label="$t('module.worker')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-text-field
                                        v-model="filter.processModelName"
                                        :label="$t('module.process_model')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                        v-model="filter.startEffectiveDate"
                                        :label="`${$t('boarding.effective_date')} ${$t('common.from')}`"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-date-picker
                                        v-model="filter.endEffectiveDate"
                                        :label="`${$t('boarding.effective_date')} ${$t('common.to')}`"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.status"
                                    :label="$t('common.status')"
                                    :items="boardingStatus"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>Employé</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <organizational-chart-select
                                        v-model="filter.organizationalchartIds"
                                        label="Organigramme"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                        v-model="filter.occupationId"
                                        label="Fonction"
                                />
                            </v-col>

                            <v-col cols="12">
                                <w-data-select-autocomplete
                                        v-model="filter.workplaceId"
                                        label="Lieu de Travail"
                                        type="WORKER_WORKPLACE"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                        v-model="filter.companyId"
                                        label="Société de déclaration"
                                        type="WORKER_COMPANY"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                        v-model="filter.stateId"
                                        label="Etat"
                                        type="WORKER_STATE"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.phase"
                                    :items="workerPhases"
                                    :label="$t('worker.status')"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>